const deliveryServiceName = {
  key: 'deliveryServiceName',
  label: 'デリバリーサービス',
  question: undefined,
} as const;
const storeState = {
  key: 'storeState',
  label: 'ステータス',
  question: undefined,
} as const;
const pendingReason = {
  key: 'pendingReason',
  label: '停止理由',
  question: undefined,
} as const;
const authStoreName = {
  key: 'authStoreName',
  label: '拠点名',
  question: undefined,
} as const;
const storeName = {
  key: 'storeName',
  label: '店舗名',
  question: undefined,
} as const;
const updatedAt = {
  key: 'updatedAt',
  label: '更新日時',
  question: undefined,
} as const;

export const deliveryStoreForm = {
  deliveryServiceName,
  storeName,
  storeState,
  pendingReason,
  authStoreName,
  updatedAt,
} as const;

const tableColumns = [
  { ...deliveryServiceName, width: '150px' },
  { ...storeState, width: '150px' },
  { ...pendingReason, width: '150px' },
  { ...authStoreName, width: '200px' },
  { ...storeName, width: '200px' },
  { ...updatedAt, width: '150px' },
] as const;

export const deliveryStoreTableThs = tableColumns.map((tableColumn) => {
  return {
    label: tableColumn.label,
    minWidth: tableColumn.width,
    question: tableColumn.question,
  };
});
